<script setup lang="ts">
import { SUPPORTED_LOCALES, setI18nLanguage } from '~/init/locale'
import { useI18n } from 'vue-i18n'

import { useModal } from '~/shared/useModal'

import Modal from '~/ui/Modal.vue'
import Button from '~/ui/Button.vue'
import Layout from '~/ui/Layout.vue'

const { t, locale } = useI18n()

const isOpen = useModal('language').isOpen
</script>

<template>
  <Modal
    v-model="isOpen"
    :priority="9"
    :title="t('components.common.UserMenu.label.language')"
  >
    <Layout
      columns
      column-width="200px"
    >
      <Button
        v-for="(language, key) in SUPPORTED_LOCALES"
        :key
        class="color-default-ghost justify-start shape-field-full"
        ui-block-size="40"
        :aria-pressed="key === locale || undefined"
        style="width: 100%;"
        @click="setI18nLanguage(key)"
      >
        {{ language }}
      </Button>
    </Layout>
  </Modal>
</template>

<style module>
  .description {
    font-size: 0.875em;
  }
</style>
